<template>
  <div class="emoji-slider">
    <el-slider
      v-model="vslider"
      :min="0"
      :max="200"
      :marks="marks"
      :show-marks="false"
      >
    </el-slider>
    {{value}}
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: 100,
      marks: {
        1:   { label: this.$createElement('div', [ '🙈', this.$createElement('span', '1%') ]) },
        25:  { label: this.$createElement('div', [ '😴', this.$createElement('span', '25%') ]) },
        50:  { label: this.$createElement('div', [ '😶', this.$createElement('span', '50%') ]) },
        75:  { label: this.$createElement('div', [ '😐', this.$createElement('span', '75%') ]) },
        100: { label: this.$createElement('div', [ '😃', this.$createElement('span', '100%') ]) },
        110: { label: this.$createElement('div', [ '😎', this.$createElement('span', '110%') ]) },
        125: { label: this.$createElement('div', [ '💪', this.$createElement('span', '125%') ]) },
        150: { label: this.$createElement('div', [ '🚀', this.$createElement('span', '150%') ]) },
        200: { label: this.$createElement('div', [ '🚀', this.$createElement('span', '200%') ]) },
      }
    }
  },
  computed: {
    vslider: {
      get() {
        return this.value;
      },
      set(v) {
        let values = Object.keys(this.marks).map(v => parseInt(v));
        var closest = values.reduce(function(prev, curr) {
          return (Math.abs(curr - v) < Math.abs(prev - v) ? curr : prev);
        });
        this.value = closest;
      }
    }
  },
  methods: {
  },
}
</script>

<style>
.emoji-slider {
  display: block;
}
.emoji-slider .el-slider {
  padding-bottom: 30px;
}
.emoji-slider .el-slider__marks-text {
  font-size: 30px;
  margin-top: -15px;
  margin-left: 5px;
}
.emoji-slider .el-slider__marks-text span {
  display: block;
  font-size: 11pt;
  font-weight: bold;
}
.emoji-slider .el-slider__button {
  width: 40px;
  height: 40px;
  border: none;
  background-color: #409EFF;
}
.emoji-slider .el-slider__marks-stop {
  display: none;
}
.emoji-slider .el-slider__button-wrapper {
  z-index: unset;
}
</style>
